import { render } from "./SIAPayments.vue?vue&type=template&id=0e6e9a38"
import script from "./SIAPayments.vue?vue&type=script&lang=js"
export * from "./SIAPayments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__